import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "hc_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const BUSINESS = {
  name: "Hingant Clean",
  phone: "0672337012",
  phoneDisplay: "06 72 33 70 12",
  email: "hingant.clean@gmail.com",
  region: "Bretagne — Côtes-d'Armor",
  logo:
    "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/k3dpg00s_Design%20sans%20titre%20%284%29.png",
  instagram: "https://www.instagram.com/hingant.clean/",
  facebook: "https://www.facebook.com/profile.php?id=61588707668769",
};

export const GALLERY_MEDIA = [
  {
    id: "video-1",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/9vkvux7y_ScreenRecording_06-12-2026%2019-12-46_1.MOV",
    title: "Nettoyage intérieur en cours",
  },
  {
    id: "video-2",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/9h80397q_ScreenRecording_06-12-2026%2018-43-10_1.MOV",
    title: "Détail vapeur",
  },
  {
    id: "video-3",
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/n2ef99jr_d95bebfc67b148ff8de7de70a7564c71.MOV",
    title: "Finitions",
  },
];

export const FORMULES = [
  {
    key: "essentielle",
    name: "Formule Essentielle",
    price: "50 €",
    duration: "2 h",
    accent: false,
    pdf: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/mjd2043p_Devis_HingantClean_Essentielle.pdf",
    items: [
      "Aspiration complète : sièges, tapis, coffre, moquette",
      "Dépoussiérage : tableau de bord, console, portes",
      "Nettoyage des plastiques intérieurs",
      "Vitres intérieures",
    ],
  },
  {
    key: "confort",
    name: "Formule Confort",
    price: "90 €",
    duration: "3 h",
    accent: false,
    pdf: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/iciy9iua_Devis_HingantClean_Confort.pdf",
    items: [
      "Tout ce qui est inclus dans la Formule Essentielle",
      "Shampoing des tapis",
      "Shampoing des sièges",
    ],
  },
  {
    key: "premium",
    name: "Formule Premium",
    price: "120 €",
    duration: "4 h",
    accent: true,
    pdf: "https://customer-assets.emergentagent.com/job_auto-detailing-pro-16/artifacts/fta2y25o_Devis_HingantClean_Premium.pdf",
    items: [
      "Tout ce qui est inclus dans la Formule Confort",
      "Nettoyage des contours des portes",
      "Désinfection habitacle à la vapeur",
    ],
  },
];

export const OPTIONS = [
  { key: "suv", label: "SUV", icon: "Car" },
  { key: "animal", label: "Poils d'animaux", icon: "PawPrint" },
  { key: "sable", label: "Sable", icon: "Hourglass" },
  { key: "tres-sale", label: "Véhicule très sale", icon: "Sparkles" },
];
